import { summerResearchSchool } from "../repositories/summerResearchSchool";

export const summerResearchSchoolService = {
  summerResearchSchool: async (body) => await summerResearchSchool(body),
};
